import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimumbaiAirportCab() {



    const cardData = {





keyword: "Navi Mumbai Airport Cab",

headingDescription: "Shreesha Tours & Travels offers dependable Navi Mumbai Airport Cab Service for airport transfers, corporate travel, family vacations, business meetings, hotel transfers, railway station pickup and drop, one-way journeys, round trips, and outstation travel. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for comfortable airport transportation. With professional drivers, flight tracking, on-time pickups, transparent pricing, doorstep service, well-maintained vehicles, and 24/7 customer support, we ensure a safe and hassle-free travel experience. Whether you are arriving at or departing from Navi Mumbai International Airport, Shreesha Tours & Travels provides reliable airport cab booking services for families, solo travelers, corporate guests, and tourists traveling across Maharashtra and nearby destinations.",

topPlaces: [
  {
    title: "Navi Mumbai Airport to Pune",
    description: "Pune is one of the busiest routes from Navi Mumbai Airport, ideal for corporate travelers, IT professionals, students, and family vacations with comfortable one-way and round-trip cab services."
  },
  {
    title: "Navi Mumbai Airport to Lonavala",
    description: "Lonavala is a popular hill station known for Tiger Point, Bhushi Dam, Rajmachi Fort, and beautiful green valleys, making it a perfect weekend getaway."
  },
  {
    title: "Navi Mumbai Airport to Mahabaleshwar",
    description: "Mahabaleshwar is famous for Venna Lake, Mapro Garden, Elephant's Head Point, strawberry farms, and pleasant weather throughout the year."
  },
  {
    title: "Navi Mumbai Airport to Nashik",
    description: "Nashik is well known for Trimbakeshwar Jyotirlinga, Panchavati, vineyards, and religious attractions, making it a preferred destination for pilgrims and tourists."
  },
  {
    title: "Navi Mumbai Airport to Shirdi",
    description: "Shirdi attracts millions of devotees every year for Sai Baba Temple, Dwarkamai, Chavadi, and spiritual experiences."
  },
  {
    title: "Navi Mumbai Airport to Kolhapur",
    description: "Kolhapur is famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and traditional Maharashtrian culture."
  },
  {
    title: "Navi Mumbai Airport to Ratnagiri",
    description: "Ratnagiri is a scenic Konkan destination known for Ganpatipule Temple, beaches, sea forts, Alphonso mangoes, and coastal beauty."
  },
  {
    title: "Navi Mumbai Airport to Goa",
    description: "Goa is India's favorite holiday destination, offering beautiful beaches, churches, forts, water sports, nightlife, and luxury resorts."
  },
  {
    title: "Navi Mumbai Airport to Saputara",
    description: "Saputara is a peaceful hill station featuring Sunset Point, Saputara Lake, Ropeway, Gira Waterfalls, and lush green surroundings."
  },
  {
    title: "Navi Mumbai Airport to Aurangabad",
    description: "Aurangabad is renowned for Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara."
  }
],


"services": [
  {
    "name": "Navi Mumbai Airport Cab",
    "description": "Book Navi Mumbai Airport Cab for safe, comfortable, and reliable airport transfers with professional chauffeurs and well-maintained AC vehicles. Enjoy timely pickup and drop services with Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, and luxury cab options. Our airport cab service ensures punctual arrivals, luggage assistance, flight tracking, and hassle-free transportation for individuals, families, business travelers, and tourists."
  },
  {
    "name": "Navi Mumbai Airport Taxi",
    "description": "Choose Navi Mumbai Airport Taxi for affordable and convenient airport transportation with experienced drivers and clean vehicles. We provide reliable pickup and drop services, transparent pricing, comfortable seating, and 24x7 taxi availability for domestic and international airport transfers."
  },
  {
    "name": "Navi Mumbai Airport Cab Booking",
    "description": "Complete Navi Mumbai Airport Cab Booking online with instant confirmation and multiple vehicle options. Book Sedan, SUV, Ertiga, Innova, Innova Crysta, Tempo Traveller, or luxury cars for airport transfers with easy reservation and flexible scheduling."
  },
  {
    "name": "Navi Mumbai Airport Taxi Service",
    "description": "Hire Navi Mumbai Airport Taxi Service for dependable airport transportation with trained chauffeurs and premium vehicles. Our taxi service offers on-time pickups, comfortable rides, flight monitoring, and reliable transfers for business travelers, families, and tourists."
  },
  {
    "name": "Cab to Navi Mumbai Airport",
    "description": "Book Cab to Navi Mumbai Airport from any location in Mumbai, Navi Mumbai, Thane, Kalyan, Dombivli, Panvel, or nearby areas. Enjoy door-to-door transportation, experienced drivers, comfortable AC vehicles, and punctual airport drop services."
  },
  {
    "name": "Taxi to Navi Mumbai Airport",
    "description": "Choose Taxi to Navi Mumbai Airport for stress-free airport transfers with professional drivers and well-maintained vehicles. Our reliable taxi service provides timely pickups, comfortable travel, and transparent fares for every passenger."
  },
  {
    "name": "Navi Mumbai Airport Drop Cab",
    "description": "Reserve Navi Mumbai Airport Drop Cab for timely airport departures with comfortable vehicles and professional chauffeurs. We ensure you reach the airport safely before your flight with convenient pickup from your home, office, hotel, or any preferred location."
  },
  {
    "name": "Navi Mumbai Airport Pickup Cab",
    "description": "Book Navi Mumbai Airport Pickup Cab for convenient airport arrival transfers. Our chauffeurs monitor flight schedules, provide timely pickups, assist with luggage, and ensure a smooth ride to your destination in Mumbai or nearby cities."
  },
  {
    "name": "Book Cab for Navi Mumbai Airport",
    "description": "Book Cab for Navi Mumbai Airport with flexible scheduling, instant confirmation, and multiple vehicle choices. Whether traveling alone, with family, or in a group, we provide comfortable airport transportation for every requirement."
  },
  {
    "name": "Online Cab Booking Navi Mumbai Airport",
    "description": "Choose Online Cab Booking Navi Mumbai Airport for quick reservations, secure booking, transparent pricing, and reliable airport transportation. Enjoy convenient online booking with a wide range of vehicles available 24x7."
  },
  {
    "name": "Navi Mumbai Airport Cab Near Me",
    "description": "Find Navi Mumbai Airport Cab Near Me with fast pickup services and reliable chauffeurs. Our nearby airport cab service offers quick response times, clean vehicles, and comfortable transportation to and from Navi Mumbai Airport."
  },
  {
    "name": "Cheapest Cab to Navi Mumbai Airport",
    "description": "Book the Cheapest Cab to Navi Mumbai Airport without compromising on comfort or safety. Enjoy affordable airport transfer packages, experienced drivers, transparent fares, and well-maintained AC vehicles for every journey."
  },
  {
    "name": "Best Cab Service Navi Mumbai Airport",
    "description": "Choose the Best Cab Service Navi Mumbai Airport for premium airport transfers with professional chauffeurs, clean vehicles, punctual service, and flexible booking options. Ideal for business travelers, families, tourists, and frequent flyers."
  },
  {
    "name": "Reliable Airport Cab Navi Mumbai",
    "description": "Hire Reliable Airport Cab Navi Mumbai for dependable airport transportation with trained drivers and quality vehicles. We provide smooth airport pickups, drops, flight tracking, and comfortable travel throughout Mumbai and surrounding areas."
  },
  {
    "name": "Innova Cab to Navi Mumbai Airport",
    "description": "Book Innova Cab to Navi Mumbai Airport for spacious and comfortable airport travel with extra luggage capacity. Ideal for families, corporate groups, and passengers seeking premium travel comfort."
  },
  {
    "name": "Ertiga Cab to Navi Mumbai Airport",
    "description": "Reserve Ertiga Cab to Navi Mumbai Airport for affordable family airport transportation with comfortable seating, professional drivers, and reliable pickup and drop services."
  },
  {
    "name": "Sedan Cab to Navi Mumbai Airport",
    "description": "Choose Sedan Cab to Navi Mumbai Airport for economical and comfortable airport transfers. Sedan vehicles are perfect for solo travelers, couples, and business professionals seeking efficient transportation."
  },
  {
    "name": "SUV Cab to Navi Mumbai Airport",
    "description": "Book SUV Cab to Navi Mumbai Airport for spacious airport travel with premium comfort and additional luggage space. Suitable for families, corporate teams, and group travelers."
  },
  {
    "name": "Tempo Traveller to Navi Mumbai Airport",
    "description": "Reserve Tempo Traveller to Navi Mumbai Airport for group airport transfers with comfortable seating and ample luggage space. Ideal for corporate teams, wedding guests, family groups, and tourist groups."
  },
  {
    "name": "Corporate Cab to Navi Mumbai Airport",
    "description": "Choose Corporate Cab to Navi Mumbai Airport for executive airport transfers with professional chauffeurs, punctual service, premium vehicles, and comfortable transportation for business executives and corporate employees."
  },
  {
    "name": "Luxury Cab Navi Mumbai Airport",
    "description": "Book Luxury Cab Navi Mumbai Airport for premium airport transportation with executive-class vehicles, experienced chauffeurs, superior comfort, and first-class travel experience."
  },
  {
    "name": "Airport Transfer Service Navi Mumbai",
    "description": "Choose Airport Transfer Service Navi Mumbai for reliable airport pickup and drop solutions with 24x7 availability, professional drivers, flight tracking, and comfortable vehicles for every travel requirement."
  },
  {
    "name": "Executive Airport Cab Navi Mumbai",
    "description": "Book Executive Airport Cab Navi Mumbai for business-class transportation with premium vehicles, courteous chauffeurs, punctual service, and comfortable airport transfers for executives and VIP guests."
  },
  {
    "name": "Innova Crysta Navi Mumbai Airport Cab",
    "description": "Reserve Innova Crysta Navi Mumbai Airport Cab for luxury airport travel with spacious seating, premium interiors, extra luggage capacity, and professional chauffeurs for a superior travel experience."
  },
  {
    "name": "Ertiga Cab Navi Mumbai Airport",
    "description": "Choose Ertiga Cab Navi Mumbai Airport for affordable and spacious airport transportation suitable for families, business travelers, and small groups with comfortable seating and reliable service."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai Airport",
    "description": "Book Swift Dzire Cab Navi Mumbai Airport for economical airport transfers with clean AC sedans, experienced chauffeurs, timely pickups, and comfortable travel."
  },
  {
    "name": "Sedan Cab Navi Mumbai Airport",
    "description": "Reserve Sedan Cab Navi Mumbai Airport for reliable airport transportation with comfortable AC cars, professional drivers, and affordable pricing for airport pickup and drop services."
  },
  {
    "name": "SUV Cab Navi Mumbai Airport",
    "description": "Choose SUV Cab Navi Mumbai Airport for spacious airport transfers with premium comfort, professional chauffeurs, and additional luggage capacity for family and group travel."
  },
  {
    "name": "Hyundai Aura Cab Navi Mumbai Airport",
    "description": "Book Hyundai Aura Cab Navi Mumbai Airport for affordable, comfortable, and reliable airport transportation with experienced drivers, clean AC vehicles, timely pickups, and convenient airport transfer services."
  }
],
"tableData": [
  ["Navi Mumbai Airport Cab", "Navi Mumbai Airport Taxi"],
  ["Navi Mumbai Airport Cab Booking", "Navi Mumbai Airport Taxi Service"],
  ["Cab to Navi Mumbai Airport", "Taxi to Navi Mumbai Airport"],
  ["Navi Mumbai Airport Drop Cab", "Navi Mumbai Airport Pickup Cab"],
  ["Book Cab for Navi Mumbai Airport", "Online Cab Booking Navi Mumbai Airport"],
  ["Navi Mumbai Airport Cab Near Me", "Cheapest Cab to Navi Mumbai Airport"],
  ["Best Cab Service Navi Mumbai Airport", "Reliable Airport Cab Navi Mumbai"],
  ["Innova Cab to Navi Mumbai Airport", "Ertiga Cab to Navi Mumbai Airport"],
  ["Sedan Cab to Navi Mumbai Airport", "SUV Cab to Navi Mumbai Airport"],
  ["Tempo Traveller to Navi Mumbai Airport", "Corporate Cab to Navi Mumbai Airport"],
  ["Luxury Cab Navi Mumbai Airport", "Airport Transfer Service Navi Mumbai"],
  ["Executive Airport Cab Navi Mumbai", "Innova Crysta Navi Mumbai Airport Cab"],
  ["Ertiga Cab Navi Mumbai Airport", "Swift Dzire Cab Navi Mumbai Airport"],
  ["Sedan Cab Navi Mumbai Airport", "SUV Cab Navi Mumbai Airport"],
  ["Hyundai Aura Cab Navi Mumbai Airport", ""]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai Airport Cab Service",
    WhyChoosedescription: "Shreesha Travels offers dependable Navi Mumbai Airport cab services for airport pickups, drops, business travel, family transfers, hotel transfers, and outstation journeys. Travel comfortably with professional chauffeurs and well-maintained vehicles."
  },
  {
    WhyChooseheading: "On-Time Airport Pickup & Drop Service",
    WhyChoosedescription: "Whether you have an early morning departure or a late-night arrival, our Navi Mumbai Airport taxi service ensures punctual pickups and timely airport transfers with real-time travel planning."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles to match your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Ideal for Business, Family & Tourist Travel",
    WhyChoosedescription: "Our Navi Mumbai Airport cabs are perfect for corporate executives, tourists, families, hotel guests, medical travellers, and local or outstation transportation needs."
  },
  {
    WhyChooseheading: "Airport Transfers & Outstation Connections",
    WhyChoosedescription: "Book cabs from Navi Mumbai Airport to Mumbai, Thane, Pune, Lonavala, Nashik, Surat, Ahmedabad, Goa, and hundreds of destinations across Maharashtra and India."
  },
  {
    WhyChooseheading: "Experienced Chauffeurs for Stress-Free Travel",
    WhyChoosedescription: "Our trained drivers monitor traffic conditions, follow efficient routes, assist with luggage, and ensure safe, comfortable, and hassle-free airport transfers."
  },
  {
    WhyChooseheading: "Clean, Sanitized & Comfortable Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, air-conditioned, sanitized, and inspected before every trip to provide a comfortable and reliable airport travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, instant booking support, professional chauffeur service, and reliable airport transportation with Shreesha Travels for every flight schedule."
  }
]

};

const faqData = [
  {
    question: "Can I pre-book a cab for Navi Mumbai Airport?",
    answer: "Yes, you can pre-book your airport cab in advance to ensure timely pickup or drop according to your flight schedule."
  },
  {
    question: "Do you provide airport pickup from Navi Mumbai Airport?",
    answer: "Yes, we offer airport pickup services with driver coordination based on your flight arrival time."
  },
  {
    question: "Which vehicles are available for Navi Mumbai Airport transfers?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a cab from Navi Mumbai Airport to another city?",
    answer: "Yes, outstation cabs are available from Navi Mumbai Airport to Pune, Nashik, Surat, Ahmedabad, Goa, and many other destinations."
  },
  {
    question: "Do you provide airport transfers for corporate travellers?",
    answer: "Yes, our airport taxi service is ideal for corporate executives, business visitors, and employee transportation."
  },
  {
    question: "Are late-night airport cab services available?",
    answer: "Yes, Navi Mumbai Airport cab services are available 24 hours a day for early morning, late-night, and scheduled flight transfers."
  },
  {
    question: "Can I book a round-trip airport taxi?",
    answer: "Yes, round-trip airport transfer packages are available with flexible return timings and customized travel plans."
  },
  {
    question: "How is the Navi Mumbai Airport cab fare calculated?",
    answer: "The fare depends on the pickup or drop location, vehicle type, travel distance, trip timing, tolls, parking charges, and selected package."
  },
  {
    question: "Do drivers help with luggage at the airport?",
    answer: "Yes, our professional chauffeurs assist passengers with luggage during pickup and drop for a convenient travel experience."
  },
  {
    question: "How can I book a Navi Mumbai Airport Cab with Shreesha Travels?",
    answer: "Simply share your flight details, pickup or drop location, travel date, passenger count, and preferred vehicle to receive a customized quote and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Desai",
    feedback: "Our Navi Mumbai Airport pickup was perfectly on time. The driver tracked our flight, the vehicle was clean, and the entire transfer was smooth and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Priti Shah",
    feedback: "Excellent airport cab service with professional support. Booking was easy, the chauffeur was courteous, and we reached our destination without any hassle.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-airport-cab.webp",
  "description":
    "Book Navi Mumbai Airport Cab with Shreesha Tours & Travels for safe and reliable airport taxi services. We provide Sedan, Ertiga, SUV, Innova, Innova Crysta, and premium cabs for airport pickup, airport drop, local transfers, corporate travel, family travel, and 24x7 airport transportation with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-airport-cab"
  }
};



    return (
        <div>

<Helmet>
  <title>Navi Mumbai Airport Cab | Airport Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai Airport Cab with Shreesha Travels for safe and comfortable airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport pickup, airport drop, local transfers, corporate travel, and 24x7 cab booking."
  />

  <meta
    name="keywords"
    content="Navi Mumbai Airport Cab, Navi Mumbai Airport Taxi, Navi Mumbai Airport Cab Booking, Navi Mumbai Airport Taxi Service, Cab to Navi Mumbai Airport, Taxi to Navi Mumbai Airport, Navi Mumbai Airport Pickup, Navi Mumbai Airport Drop, Airport Cab Navi Mumbai, Airport Taxi Navi Mumbai, Navi Mumbai Airport Transfer, Navi Mumbai Airport Car Rental"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/83.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimumbaiAirportCab;